import $ from 'jquery'

const localStorageKey = 'hideSubscribePopover'
const hideDuration = 7 * 86400000 // 7 days in milliseconds

let $popovers = null

let scrollDelta = 0
let open = false
let dismissed = detectDismissed()
let lastScrollPosition = $(document).scrollTop()
let raf = null

export function initialise() {
  if ($('[data-subscribe-popover]').length === 0) return

  if (raf) window.cancelAnimationFrame(raf)
  $(window).off('scroll', handleScroll)
  $(window).on('scroll', handleScroll)
  $('body').on('ajax.replace', initPopovers)
  initPopovers()
  raf = window.requestAnimationFrame(enterFrame)
}

function detectDismissed() {
  let val = localStorage.getItem(localStorageKey)
  if (val === 'Infinity') return true
  val = parseInt(val, 10)
  if (isNaN(val)) return false
  return val > Date.now() - hideDuration
}

function initPopovers() {
  lastScrollPosition = $(document).scrollTop()
  $popovers = $('[data-subscribe-popover]')
  $popovers.each((i, elem) => {
    const $popover = $(elem)
    const $closeButton = $popover.find('.close-button')

    if ($popover.find('[data-auto-dismiss-popover]').length > 0) {
      localStorage.setItem(localStorageKey, 'Infinity')
      dismissed = true
      setTimeout(() => {
        $popover.removeClass('open')
        open = false
      }, 10000)
    }

    $closeButton.on('click', () => {
      $popover.removeClass('open')
      open = false
      if (localStorage.getItem(localStorageKey) !== 'Infinity') {
        localStorage.setItem(localStorageKey, Date.now())
      }
      dismissed = true
    })
  })
}

function enterFrame() {
  scrollDelta /= 2
  if (!dismissed) {
    if (scrollDelta <= -5 && open) {
      $popovers.removeClass('open')
      open = false
    } else if (scrollDelta >= 5 && !open) {
      $popovers.addClass('open')
      open = true
    }
    raf = window.requestAnimationFrame(enterFrame)
  }
}

function handleScroll(e) {
  const newPos = $(document).scrollTop()
  scrollDelta += newPos - lastScrollPosition
  lastScrollPosition = newPos
}
